/* Dizzplace - zestaw probek w koszyku.

   Zestaw to nosnik (cena) plus probki (osobne pozycje, zerowane rabatem).
   Ten skrypt robi trzy rzeczy:
     1. "Usun zestaw" zdejmuje wszystkie pozycje zestawu naraz i daje 6 sekund
        na cofniecie tym samym paskiem, co lista zyczen.
     2. Po wejsciu na strone sprawdza, czy kazdy zestaw jest spojny: nosnik ma
        wariant rowny liczbie probek, a kazda pozycja stoi w jednej sztuce.
        Rozjazd bierze sie tylko z reczne j grzebaniny w adresach, ale wtedy
        klient placilby za wiecej wzorow, niz dostaje - wiec przeliczamy w dol.
     3. Link "Edytuj zestaw" dostaje liste wariantow z chipow, zeby konfigurator
        mogl wstawic je na sloty.
*/
(() => {
  const PAMIEC = 'dizz_cart_set_undo';
  const STRAZNIK = 'dizz_cart_set_normalised';

  const json = (url, opts) =>
    fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {})).then(
      (r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }
    );

  const koszyk = () => json('/cart.js');
  const dodaj = (items) => json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });

  /* Kilka pozycji naraz JEDNYM zadaniem. Po kazdej pojedynczej zmianie Shopify
     przelicza rabaty i uniewaznia zapamietane klucze pozostalych pozycji -
     seria wywolan padala na drugim z bledem 400 „nieprawidlowy identyfikator". */
  const ustawIlosci = (updates) => json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });

  const pasek = (opcje) => {
    if (window.wishlistBar && typeof window.wishlistBar.show === 'function') window.wishlistBar.show(opcje);
  };

  const czytajNapisy = () => {
    const el = document.querySelector('[data-cart-set-copy]');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  };

  const pozycjeZestawu = (items, numer) => items.filter((p) => p.properties && p.properties._zestaw === numer);

  /* Pozycja z /cart.js -> to, co trzeba wyslac do /cart/add.js, zeby ja odtworzyc. */
  const doOdtworzenia = (p) => ({ id: p.variant_id, quantity: p.quantity, properties: p.properties || {} });

  /* ---------- 1. usuniecie zestawu z cofnieciem ---------- */

  const usunZestaw = async (wiersz, napisy) => {
    const numer = wiersz.dataset.cartSet;
    const przycisk = wiersz.querySelector('[data-cart-set-remove]');
    if (przycisk) przycisk.disabled = true;

    try {
      const stan = await koszyk();
      const pozycje = pozycjeZestawu(stan.items || [], numer);
      const updates = {};
      pozycje.forEach((p) => { updates[p.key] = 0; });
      await ustawIlosci(updates);

      /* Pasek z cofnieciem musi przezyc przeladowanie, wiec zapas idzie do
         pamieci sesji i odzywa po wczytaniu strony. */
      window.sessionStorage.setItem(
        PAMIEC,
        JSON.stringify({ kiedy: Date.now(), items: pozycje.map(doOdtworzenia) })
      );
      window.location.reload();
    } catch (e) {
      if (przycisk) przycisk.disabled = false;
      pasek({ text: napisy.error || '', error: true });
    }
  };

  const zaproponujCofniecie = (napisy) => {
    let zapas = null;
    try {
      zapas = JSON.parse(window.sessionStorage.getItem(PAMIEC) || 'null');
    } catch (e) {
      zapas = null;
    }
    window.sessionStorage.removeItem(PAMIEC);
    if (!zapas || !Array.isArray(zapas.items) || !zapas.items.length) return;
    if (Date.now() - (zapas.kiedy || 0) > 60000) return;

    pasek({
      text: napisy.removed || '',
      undo: async () => {
        try {
          await dodaj(zapas.items);
          window.location.reload();
        } catch (e) {
          pasek({ text: napisy.error || '', error: true });
        }
      },
    });
  };

  /* ---------- 2. spojnosc zestawow ---------- */

  const znormalizuj = async () => {
    if (window.sessionStorage.getItem(STRAZNIK) === '1') {
      window.sessionStorage.removeItem(STRAZNIK);
      return;
    }

    const stan = await koszyk();
    const items = stan.items || [];
    const nosniki = items.filter((p) => p.properties && p.properties._zestaw_rola === 'nosnik' && p.properties._zestaw);
    let zmieniono = false;

    /* Wszystkie poprawki ilosci ida jednym zadaniem na koncu - patrz uwaga
       przy ustawIlosci. Nowe nosniki dokladamy osobno, bo to inne zadanie. */
    const poprawki = {};
    const doDolozenia = [];

    for (const nosnik of nosniki) {
      const numer = nosnik.properties._zestaw;
      const probki = items.filter((p) => p.properties && p.properties._zestaw === numer && p.properties._zestaw_rola === 'probka');
      const warianty = String(nosnik.properties._zestaw_warianty || '').split(',').filter(Boolean).map(Number);

      /* Probka w zestawie to zawsze jedna sztuka. */
      for (const p of probki) {
        if (p.quantity !== 1) poprawki[p.key] = 1;
      }

      const liczba = probki.length;

      if (liczba === 0) {
        poprawki[nosnik.key] = 0;
        continue;
      }

      const oczekiwany = warianty[liczba - 1];
      const zlyWariant = oczekiwany && nosnik.variant_id !== oczekiwany;
      /* Nosnik ma tyle sztuk, ile probek - od tego zalezy cena i rabat. */
      const zlaIlosc = nosnik.quantity !== liczba;

      if (zlyWariant || zlaIlosc) {
        /* Nosnik na nowo: wlasciwy wariant, tyle sztuk co probek, a czytelne wpisy
           "Probka nr N" przepisane z probek, ktore naprawde zostaly. */
        const wlasciwosci = Object.assign({}, nosnik.properties);
        const kluczeWidoczne = Object.keys(wlasciwosci).filter((k) => k.charAt(0) !== '_');
        kluczeWidoczne.forEach((k) => delete wlasciwosci[k]);
        probki.forEach((p, i) => {
          const klucz = kluczeWidoczne[i];
          if (klucz) wlasciwosci[klucz] = String(p.product_title || '').split('—')[0].trim();
        });

        doDolozenia.push({ id: oczekiwany || nosnik.variant_id, quantity: liczba, properties: wlasciwosci });
        poprawki[nosnik.key] = 0;
      }
    }

    /* Probka z zestawu, ktorego nosnika juz nie ma: probki kosztuja 0 EUR
       z jednego rabatu na cala kolekcje probek, a cene zestawu niesie nosnik -
       bez nosnika bylaby darmowa. Szuflada koszyka robi to samo. */
    const numeryNosnikow = new Set(nosniki.map((n) => n.properties._zestaw));
    items
      .filter((p) => p.properties && p.properties._zestaw_rola === 'probka' && !numeryNosnikow.has(p.properties._zestaw))
      .forEach((p) => { poprawki[p.key] = 0; });

    if (Object.keys(poprawki).length) {
      await ustawIlosci(poprawki);
      zmieniono = true;
    }
    if (doDolozenia.length) {
      await dodaj(doDolozenia);
      zmieniono = true;
    }

    if (zmieniono) {
      window.sessionStorage.setItem(STRAZNIK, '1');
      window.location.reload();
    }
  };

  /* ---------- 3. link edycji z lista wzorow ---------- */

  const uzupelnijLinkiEdycji = () => {
    document.querySelectorAll('[data-cart-set]').forEach((wiersz) => {
      const link = wiersz.querySelector('[data-cart-set-edit]');
      if (!link) return;
      const ids = [...wiersz.querySelectorAll('[data-cart-set-chip]')].map((c) => c.dataset.variantId).filter(Boolean);
      link.href = link.getAttribute('href') + ids.join(',');
    });
  };

  const init = () => {
    const root = document.querySelector('[data-cart]');
    if (!root || root.dataset.gotowe === 'true') return;
    root.dataset.gotowe = 'true';

    const napisy = czytajNapisy();
    uzupelnijLinkiEdycji();

    root.querySelectorAll('[data-cart-set]').forEach((wiersz) => {
      const przycisk = wiersz.querySelector('[data-cart-set-remove]');
      if (przycisk) przycisk.addEventListener('click', () => usunZestaw(wiersz, napisy));
    });

    zaproponujCofniecie(napisy);
    znormalizuj().catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
